import { combineReducers } from '@reduxjs/toolkit';
import auth from './auth/authSlice';
import profile from './profile/profileSlice';
import users from './admin/users/userSlice';
import registers from './admin/registers/registerSlice';
import profiles from './admin/profiles/profileSlice';

export default combineReducers({ auth, profile, users, registers, profiles });
